module.exports = __webpack_public_path__ + "img/GUP.180bc5b3.svg";